export default {
  en: {
    pageTitle: 'Certificate Authorities',
    boxTitle: 'Certificate Authorities',
    btnDelete: 'Delete',
    btnEdit: 'Edit',
    btnSave: 'Save',
    fillName: "Name can't be empty",
    btnUploadCA: 'Upload CA',
    columns: {
      name: 'Name',
      issuedAt: 'Issued at',
      expiresAt: 'Expires at',
    },
    confirmDelete: {
      header: 'Certificate authority will be deleted',
      subHeader: 'Do you really want to delete the certificate authority?',
      btnConfirm: 'Delete',
      btnSecondaryConfirm: 'Cancel',
    },
    msgNameAlreadyExist:
      'Upload failed, please use different name. The specified is already stored.',
    msgCertificateUploaded: 'Certificate uploaded',
  },
};
